import React from 'react';
import { Award } from 'lucide-react';
export function AboutCreator() {
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-132">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-133">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-134">
          <div className="relative" data-id="element-135">
            <div className="absolute -inset-4 bg-[#C2410C]/10 rounded-3xl transform -rotate-3" data-id="element-136"></div>
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&q=80" alt="Isabella Romero" className="relative w-full h-auto rounded-2xl shadow-xl object-cover aspect-[4/5]" data-id="element-137" />
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-xl border border-[#3E2723]/10 flex items-center gap-3" data-id="element-138">
              <div className="bg-[#14B8A6]/10 p-2 rounded-full text-[#14B8A6]" data-id="element-139">
                <Award className="w-6 h-6" data-id="element-140" />
              </div>
              <div className="text-sm font-bold text-[#3E2723]" data-id="element-141">
                5+ years of resort
                <br data-id="element-142" />
                kitchen research
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-143">
            <h2 className="text-4xl md:text-5xl text-[#3E2723]" data-id="element-144">
              Meet Your Guide
            </h2>
            <div className="space-y-4 text-lg text-[#3E2723]/80 leading-relaxed" data-id="element-145">
              <p data-id="element-146">
                Hi, I'm Isabella Romero. Like you, I fell in love with the
                vibrant, smoky, and complex flavors of authentic Mexican cuisine
                while traveling through Oaxaca, Tulum, and Cabo.
              </p>
              <p data-id="element-147">
                But when I returned to the US, I was frustrated. The recipes I
                found online either tasted like generic Tex-Mex or required me
                to hunt down rare ingredients that my local grocery store didn't
                carry. I wanted real resort-quality food without the hassle.
              </p>
              <p data-id="element-148">
                So, I spent 5 summers traveling back to Mexico, stagiering in 3
                different 5-star resort kitchens. I begged the local chefs to
                teach me their secrets, and then I spent years in my own kitchen
                decoding those traditional recipes for the American supermarket.
                The result is the "Swap Map" — your shortcut to authentic
                flavor.
              </p>
            </div>
            <div className="pt-4" data-id="element-149">
              <div className="font-[Satisfy,cursive] text-3xl text-[#C2410C] italic" data-id="element-150">
                Isabella Romero
              </div>
              <div className="text-sm text-[#3E2723]/60 uppercase tracking-widest mt-1" data-id="element-151">
                Creator & Food Researcher
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}